"use client";

import { useEffect, useState, Suspense, lazy } from "react";
import { useTranslation } from "react-i18next";
import Sidebar from "../compnents/Sidebar";
import { BASE_URL } from "../config/constants";

const ArticleCard = lazy(() => import("../compnents/cards/ArticleCard"));

const Projects = () => {
  const { t } = useTranslation();
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null); // لتخزين الخطأ

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const res = await fetch(
          `${BASE_URL}/api/v1/courses/public?page=1&limit=50`
        );

        // تحقق من حالة الاستجابة
        if (!res.ok) {
          setError(res.status); // خزن كود الخطأ
          setProjects([]);
          return;
        }

        const data = await res.json();
        const projectCourses =
          data?.courses?.filter((course) => course.type === "PROJECT") || [];

        if (projectCourses.length === 0) {
          setError("NO_PROJECTS"); // حالة عدم وجود كورسات
        }

        setProjects(projectCourses);
      } catch (err) {
        console.error("Error fetching courses:", err);
        setError("NETWORK_ERROR"); // خطأ في الشبكة
        setProjects([]);
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, []);

  const renderContent = () => {
    if (loading) return <p className="text-center text-gray-500">Loading...</p>;

    if (error) {
      switch (error) {
        case 404:
          return (
            <p className="text-center text-red-500">Error 404: Not Found</p>
          );
        case 500:
        case 501:
          return (
            <p className="text-center text-red-500">Server Error {error}</p>
          );
        case "NO_PROJECTS":
          return (
            <p className="text-center text-gray-500">No projects available</p>
          );
        case "NETWORK_ERROR":
        default:
          return (
            <p className="text-center text-red-500">
              Network error. Please try again.
            </p>
          );
      }
    }

    return (
      <div className="flex flex-col lg:flex-row gap-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 flex-1">
          <Suspense fallback={<p>Loading projects...</p>}>
            {projects.map((project) => (
              <ArticleCard
                key={project.id}
                title={project.name}
                description={project.about}
                image={
                  project.photoId
                    ? `${BASE_URL}/uploads/${project.photoId}`
                    : "/images/about.png"
                }
              />
            ))}
          </Suspense>
        </div>
        <Sidebar />
      </div>
    );
  };

  return (
    <div className="mt-20">
      <section className="bg-main h-[35vh] md:h-[50vh] flex justify-center items-center mb-16">
        <h2 className="text-2xl md:text-5xl text-white font-semibold">
          {t("Projects")}
        </h2>
      </section>

      <main className="min-h-screen bg-gray-50 text-black px-6 py-10">
        <h1 className="text-center text-blue-700 text-3xl font-bold mb-10">
          {t("Projects")}
        </h1>

        {renderContent()}
      </main>
    </div>
  );
};

export default Projects;
